import { useMutation } from "urql";

import { CreateRiskReviewDocument } from "../../../graphql/generated.ts";

export const useCreateRiskReview = () => useMutation(CreateRiskReviewDocument);
